import React from 'react';
import { Settings, Wallet, Gauge } from 'lucide-react';
import InputLabel from '../../../components/base/InputLabel';
import NumberInput from '../../../components/base/NumberInput';
import Parameter from '../../../components/base/Parameter';
import { ERROR_MESSAGES } from '../../../errors/constants';
import { MIN_VALUES } from '../../../constants/minValues';

const StocksHeader = ({ values, setValues, onOpenSettings, errors = {}, extremePriceField, metrics = {} }) => {
    return (
        <div className="p-4 sm:p-6 lg:p-8 flex flex-col lg:flex-row gap-4 lg:gap-6 lg:items-start">
            <div className="grid grid-cols-2 gap-3 lg:contents">
                <div className="w-full lg:w-72">
                    <div className="flex justify-between items-center mb-2">
                        <InputLabel variant="header" required>Entry price</InputLabel>
                    </div>
                    <NumberInput
                        value={values.entryPrice}
                        onChange={(value) => setValues(prev => ({ ...prev, entryPrice: value }))}
                        decimals={2}
                        required
                        min={MIN_VALUES.entryPrice}
                        name="entryPrice"
                        error={errors.entryPrice ? { message: ERROR_MESSAGES.INVALID_ENTRY_PRICE } : null}
                        highlight={extremePriceField === 'entryPrice'}
                        copyEnabled={true}
                    />
                </div>

                <div className="w-full lg:w-72">
                    <div className="flex justify-between items-center mb-2">
                        <InputLabel variant="header" required>Stop-loss</InputLabel>
                    </div>
                    <NumberInput
                        value={values.stopLoss}
                        onChange={(value) => setValues(prev => ({ ...prev, stopLoss: value }))}
                        decimals={2}
                        required
                        min={MIN_VALUES.stopLoss}
                        name="stopLoss"
                        error={errors.stopLoss ? { message: ERROR_MESSAGES.INVALID_STOP_LOSS } : null}
                        highlight={extremePriceField === 'stopLoss'}
                        copyEnabled={true}
                    />
                </div>
            </div>

            <div className="flex-1">
                <div className="flex justify-between items-center mb-2">
                    <InputLabel variant="header">Parameters</InputLabel>
                    <button
                        onClick={onOpenSettings}
                        className="flex items-center gap-1.5 text-slate-500 text-sm hover:text-slate-400 transition-colors tracking-wide"
                    >
                        Settings <Settings size={14} />
                    </button>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:flex gap-2 lg:gap-3 mt-[6px]">
                    <Parameter
                        value={`${values.maxLeverage}x`}
                        onChange={setValues}
                        isDirectEditable={true}
                    >
                        <Gauge size={16} className="text-slate-500 mr-2" />
                    </Parameter>
                    <Parameter
                        label="Risk"
                        value={values.riskUnit === 'percent' ? `${values.risk}%` : `$${values.risk}`}
                        onChange={setValues}
                        isDirectEditable={true}
                    />
                    <Parameter
                        label={values.multiTpEnabled ? "TPs" : "R:R"}
                        value={`${values.nominalRR}x`}
                        onChange={setValues}
                        isDirectEditable={true}
                        staticDisplay={values.multiTpEnabled ? String(values.tpCount) : undefined}
                        onOpenSettings={onOpenSettings}
                    />
                    <Parameter
                        label="Fees"
                        value={metrics?.feeBreakdown?.total || 'Custom'}
                        onChange={setValues}
                        onOpenSettings={onOpenSettings}
                    />
                    <Parameter
                        icon={Wallet}
                        value={`$${values.accountBalance}`}
                        onChange={setValues}
                        onOpenSettings={onOpenSettings}
                    />
                </div>
            </div>
        </div>
    );
};

export default StocksHeader;
